import React, { useState } from 'react';
import { Box, Container, useTheme, useMediaQuery } from '@mui/material';
import TopBar from '../components/TopBar';
import Sidebar from '../components/Sidebar';
import TransactionsTable from '../components/TransactionsTable';
interface TransactionViewProps {
  onLogout: () => void;
}
const TransactionView: React.FC<TransactionViewProps> = ({
  onLogout
}) => {
  const [mobileOpen, setMobileOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  return <Box sx={{
    display: 'flex',
    minHeight: '100vh',
    backgroundColor: '#F8FAFC'
  }} data-id="element-5108">
      <TopBar onMenuClick={handleDrawerToggle} onLogout={onLogout} data-id="element-5109" />
      <Sidebar open={mobileOpen} onClose={handleDrawerToggle} activePage="transactions" data-id="element-5110" />
      <Box component="main" sx={{
      flexGrow: 1,
      py: 2,
      px: 1,
      width: {
        sm: `calc(100% - ${240}px)`
      },
      ml: 0,
      mt: 8
    }} data-id="element-5111">
        <Container maxWidth="xl" data-id="element-5112">
          <TransactionsTable searchQuery={searchQuery} data-id="element-5113" />
        </Container>
      </Box>
    </Box>;
};
export default TransactionView;